import { Client } from 'api/getClient';

export const shouldNavigateToFinance = (client: Client | null | undefined) =>
  Boolean(client?.mobilePhoneVerified) && !client?.employer?.employmentStatus;
